<template>
    <div class="inputs">

        <div class="recuperar">
        <Loading/>
            <h4>RECUPERAR SENHA</h4>

            <p>Para prosseguir, informe seu email cadastrado para receber as instruções de recuperação senha.</p>
        </div>
        <input type="text" v-model="email" id="" class="form-control mb-3" placeholder="usuario@email.com.br"/>
        <button class="btn text-white conectar col-12" type="button" @click="login">Enviar E-mail</button>
    </div>
</template>

<script>
    let axios = require('axios');

    import Login from "./Login";
    import Loading from "./Loading";

    export default {
        name: 'Login',

        data() {
            return {
                email: ''
            }
        },

        components: {
            Loading
        },

        mounted() {
            // this.$swal('Erro no Login', 'Usuário e/ou senha incorretos', 'error')
        },

        methods: {
            login() {
                let thisVue = this;


                API.enviarRequisicao('post', '/api/controleacesso/resetarSenha', {
                    ba01_email: this.email
                }).then(function () {
                    thisVue.$swal('E-mail enviado com sucesso','Acesse seu e-mail para recuperar sua senha','success').then(function () {
                        thisVue.$parent.componente = Login;
                        thisVue.$parent.login = true;
                    });
                }).catch(function () {
                    thisVue.$swal('Erro de conexão com o servidor', '', 'error');
                });
            }
        }
    }
</script>

<style scoped>
    .recuperar {
        color: #888;
    }

    .conectar {
        background-color: #141E37;
        border-bottom: 4px solid #505a82;
    }
    button:hover {
        background-color: #030d26 !important;
    }

</style>
